import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDirectionUp(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18.707 15.707a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414L12 10.414l5.293 5.293a1 1 0 0 0 1.414 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
